export type ApiHealth = 'ok' | 'slow' | 'down' | 'checking';

const SLOW_MS = 800;
const TIMEOUT_MS = 3000;

export async function pingApiHealth(): Promise<{ state: ApiHealth; latencyMs: number | null }> {
  const controller = new AbortController();
  const timer = window.setTimeout(() => controller.abort(), TIMEOUT_MS);
  const startedAt = performance.now();
  try {
    const res = await fetch('/v1/health', {
      method: 'GET',
      signal: controller.signal,
      cache: 'no-store',
    });
    const latencyMs = performance.now() - startedAt;
    if (!res.ok) return { state: 'down', latencyMs };
    const body = (await res.json().catch(() => null)) as { status?: string } | null;
    if (body?.status !== 'ok') return { state: 'down', latencyMs };
    return { state: latencyMs >= SLOW_MS ? 'slow' : 'ok', latencyMs };
  } catch {
    return { state: 'down', latencyMs: null };
  } finally {
    window.clearTimeout(timer);
  }
}
